import React, { useState, useEffect, Fragment } from "react";
import { useLocation } from "react-router-dom";
import { getFamiliasImg } from "../repository";
import ResponsiveHeader from "../components/ResponsiveHeader";
import Footer2 from "../components/Footer2";
import ProductItems from "../components/ProductItems";

const Products = () => {
  const [familias, setFamilias] = useState([]);
  const [selectedFamilia, setSelectedFamilia] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // Mapeo de hash a índice de familia
  const getIndexFromHash = (hash) => {
    const hashMap = {
      '#Nav-1': 0, // Suspensión
      '#Nav-2': 1, // Tracción
      '#Nav-3': 2, // Dirección
      '#Nav-4': 3, // Soportes
    };
    return hashMap[hash] ?? 0;
  };

  const obtieneFamiliasInicio = () => {
    setLoading(true);
    getFamiliasImg()
      .then((response) => {
        if (response.status === 200) {
          const data = response.data.result;
          setFamilias(data);
          if (data.length > 0) {
            // Seleccionar familia según el hash de la URL
            const index = getIndexFromHash(location.hash);
            const familiaIndex = Math.min(index, data.length - 1);
            setSelectedFamilia(data[familiaIndex].idFamilia);
          }
        } else {
          setFamilias([]);
        }
      })
      .catch(() => {
        setFamilias([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    obtieneFamiliasInicio();
  }, [location.hash]);

  const handleFamiliaClick = (idFamilia) => {
    setSelectedFamilia(idFamilia);
  };

  return (
    <Fragment>
      <ResponsiveHeader />

      {/* Hero Banner */}
      <div className="products-hero">
        <div className="container">
          <div className="products-hero-content">
            <h1 className="products-hero-title">Nuestros Productos</h1>
            <p className="products-hero-subtitle">
              Calidad y rendimiento para tu vehículo
            </p>
          </div>
        </div>
      </div>

      {/* Categorías de Productos */}
      <div className="products-categories-section">
        <div className="container">
          {loading ? (
            <div className="products-loading">
              <div className="spinner-border text-warning" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
              <p>Cargando categorías...</p>
            </div>
          ) : (
            <Fragment>
              {/* Navegación de Categorías */}
              <div className="products-category-nav">
                {familias.map((item) => (
                  <button
                    key={item.idFamilia}
                    className={`category-chip ${selectedFamilia === item.idFamilia ? "active" : ""}`}
                    onClick={() => handleFamiliaClick(item.idFamilia)}
                  >
                    {item.strDescripcion}
                  </button>
                ))}
              </div>

              {/* Contenido de Productos */}
              <div className="products-content">
                {selectedFamilia && (
                  <ProductItems idFamilia={selectedFamilia} />
                )}
              </div>
            </Fragment>
          )}
        </div>
      </div>

      <Footer2 />
    </Fragment>
  );
};

export default Products;
